const controller = "company-settings";

export default {
  controller,
  map: controller + "/map",
  mapByOfficeTypes: controller + "/map/by-office-types",
};
